import { render } from "./SidebarLeft.vue?vue&type=template&id=1851e8bc&scoped=true"
import script from "./SidebarLeft.vue?vue&type=script&lang=js"
export * from "./SidebarLeft.vue?vue&type=script&lang=js"

import "./SidebarLeft.vue?vue&type=style&index=0&id=1851e8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1851e8bc"]])

export default __exports__